import dedent from 'ts-dedent';
import { Provider, WorkflowComponentParamType, WorkflowParameterValueErrorType } from '../types';
import { isExpressionValue, isSingleVariable } from '../utils';
import { SelectSameSchemaWorkflowComponent } from './common/selectsameschemacomponent';
class Limit extends SelectSameSchemaWorkflowComponent {
    constructor() {
        super({
            name: 'native.limit',
            group: 'Data Preparation',
            title: 'Limit',
            description: `
      This component creates a new table with only the N first rows of the input table.
      `,
            starred: true
        }, [
            {
                name: 'source',
                type: WorkflowComponentParamType.InputTable,
                title: 'Source table'
            },
            {
                name: 'limit',
                type: WorkflowComponentParamType.Number,
                title: 'Number of rows',
                min: 1,
                default: 10
            }
        ]);
        this.requiresDynamicSQL = true;
    }
    checkInputValues({ params, resolvedParamValues, connection, dryRun, schemas, variables }) {
        const problems = super.checkInputValues({
            params,
            resolvedParamValues,
            connection,
            dryRun,
            schemas,
            variables
        });
        if (params.limit &&
            isExpressionValue(params.limit) &&
            !isSingleVariable(params.limit)) {
            problems.push({
                parameter: 'limit',
                type: WorkflowParameterValueErrorType.WrongValue,
                message: 'Expressions are not allowed in this component. Only simple variables are supported'
            });
        }
        return problems;
    }
    getInnerSql({ params, connection }) {
        const limit = `${params.limit}`.replace(/[\(\)]/g, ''); // remove parentheses if expression
        if (connection.type === Provider.DatabricksRest) {
            return dedent `SELECT /*+ REPARTITION(40) */
                *
              FROM ${connection.quoteName(params.source)}
              LIMIT ${limit}`;
        }
        else {
            return dedent `SELECT *
              FROM ${connection.quoteName(params.source)}
              LIMIT ${limit}`;
        }
    }
}
export { Limit };
